import React, { useEffect, useState } from "react";
import { correctPublicationsAtom } from "../utils/hooks/LoadingHook";
import { useAtom } from "jotai";
import { ONE, UNDEFINED } from "../App";
import QueryingForTotalPages from "../QueryingForTotalPages";

/**
 *  Properties for the publication information
 */
type LoadTotalPagesProps = {
    setLoaded: (isLoaded: boolean) => void;
};

/**
 *  Loads all publication information needed for the analytics
 *
 * @params setLoaded Checks if all the information has been loaded
 * @returns {JSX.Element} all loaded publications after querying
 */
export const LoadTotalPages = ({ setLoaded }: LoadTotalPagesProps) => {
	const [correctPublications] = useAtom(correctPublicationsAtom);
	const publicationsLength = correctPublications.length;
	const [arrayIndex, setArrayIndex] = useState(UNDEFINED - ONE);

	useEffect(() => {
		if (arrayIndex + ONE === publicationsLength) {
			setLoaded(true);
		}
	}, [arrayIndex]);

	return (
		<div>
			{
				(correctPublications.length > UNDEFINED &&
					correctPublications.map((publication) => {
						return (
							<QueryingForTotalPages
								key={publication.id}
								publicationId={publication.id}
								amount={(amount) => {
									publication.data.totalPages = amount;
									setArrayIndex(arrayIndex + ONE);
								}}
							/>
						);
					})
				)
			}
		</div>
	);
};

export default LoadTotalPages;